import { combineReducers } from 'redux'
import selected from './get-one'
import all from './get-all'
import newOne from './new'
import editOne from './edit'
import editTypes from './edit-responsible-types'
import deleteOne from './delete'
import customers from './get-customers'

const reducer = combineReducers({
  selected,
  all,
  newOne,
  editOne,
  editTypes,
  deleteOne,
  customers
})

export default reducer
